import getGraphQlClient from '~graphql/getGraphQlClient';
import { CREATE_DISABLED_USER_FEATURE } from '~graphql/queries/features';
import { getUser } from '~src/user';
import { onErrorShowMessage } from '~src/errors';

/**
 * Create a Features_preference record for the current user/org.
 * @param {Object} options
 * @param {string} options.key - Feature key, e.g. 'giotto.v2_beta_group'
 * @param {boolean} [options.disabled=false] - Whether the feature is disabled for this user
 * @param {string} [options.product='giotto'] - Product name
 * @returns {Promise<Object>} Created features_preference (partial)
 */
export const createFeaturePreference = async ({
  key,
  disabled = false,
  product = 'giotto',
}) => {
  try {
    const client = await getGraphQlClient();
    const { user } = await getUser();
    const orgId = user.org_pointer.objectId;

    const variables = {
      fields: {
        key,
        disabled,
        product,
        org_pointer: { link: orgId },
        user_pointer: { link: user.objectId },
      },
    };

    const { data } = await client.mutate({
      mutation: CREATE_DISABLED_USER_FEATURE,
      variables,
    });

    return data?.createFeatures_preference?.features_preference;
  } catch (error) {
    console.error('createFeaturePreference error', error);
    await onErrorShowMessage(false);
    throw error;
  }
};
